<template>
    <v-dialog
        v-model="qteDialog"
        width="700"
        
    >
    <!-- <v-card> -->
    <v-card >
        <v-toolbar height="auto" flat class="pa-2">
            <v-toolbar-title class="w-100">
                <v-row align="center" no-gutters>
                <v-col cols="auto">
                    <v-avatar color="primary" size="32" class="mr-3">
                    <v-icon dark size="18">mdi-tag</v-icon>
                    </v-avatar>
                </v-col>
                <v-col>
                    <div class="text-subtitle-1 font-weight-bold">
                    {{ props.article.reference_y2 }}
                    </div>
                    <v-chip size="x-small" v-if="props.type.type=='color'" class="text-caption grey--text">
                        Couleur: {{ props.article.couleur }}
                    </v-chip>
                    <v-chip size="x-small" v-if="props.type.type=='color'&&props.article.taille" class="text-caption grey--text">
                        Taille: {{ props.article.taille }}
                    </v-chip>
                    <v-chip size="x-small" v-if="props.type.type=='color'" class="text-caption grey--text">
                        Code-barres: {{ props.article.codebarre }}
                    </v-chip>
                </v-col>
                <v-col cols="auto">
                    <v-btn icon small @click="qteDialog=false">
                    <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-col>
                </v-row>
            </v-toolbar-title>
        </v-toolbar>
        <v-tabs v-model="tab" bg-color="grey" height="40">
            <v-tab value="one" >Compteurs Y2</v-tab>
            <v-tab value="two" > Infos</v-tab>
        </v-tabs> 
        <v-tabs-window v-model="tab" >
            <v-tabs-window-item value="one" >
            <v-card >
                <!-- <v-card-title class="text-h5">
                    Consultation des compteurs
                </v-card-title> -->
                
                <v-card-text style="max-height: 700px; overflow-y: auto;">
                    <!-- Sélection du magasin -->
                    <v-row>
                        <v-col cols="5">
                            <v-combobox 
                                label="Sélectionnez un magasin"
                                v-model="selectedStoreId"
                                :items="props.storeOptions"
                                variant="outlined"
                                density="compact"
                                clearable
                                @update:model-value="updateDisplayedQuantities"
                            ></v-combobox>
                        </v-col>
                    </v-row>
                    
                    <!-- Tableau des quantités -->
                    <v-data-table
                    v-if="displayedQuantities.length > 0"
                    :headers="headers"
                    :items="displayedQuantities"
                    :items-per-page="-1"
                    hide-default-footer
                    class="elevation-1"
                    density="compact"
                    >
                    <template #item.label="{ item }">
                        <v-chip
                        size="small"
                        @click="selectedQuantityPrime=item.label"
                        >
                        {{ quantityLabels[item.label].libelle }}
                        </v-chip>
                      
                    </template>
                    <template #item.type="{ item }">
                        <v-icon v-if="item.type!=''&&item.type!='package'"  :color="item.type=='plus'&&item.quantity>0?'green':'red'" :icon="`mdi-checkbox-marked-circle-${item.type=='plus'&&item.quantity>0?'plus':'minus'}-outline`"></v-icon>
                        <v-icon v-if="item.type=='package'" :color="`${item.quantity>=0?'blue':'red'}`" :icon="`${item.quantity>=0?'mdi-package-variant-closed':'mdi-package-variant-minus'}`"></v-icon>
                        <v-chip size="x-small" class="dimension-vatican" v-if="item.label=='transferRequestQuantity'&&crossDock" color="blue" > {{`${crossDock?'Cross Dock':'Réassort'}`}}</v-chip>
                        
                        <!-- <v-chip v-if="">{{  }}</v-chip> -->
                    </template>
                    <!-- :color="getQuantityColor(item.quantity)" -->
                    <template #item.quantity="{ item }">
                        <v-chip
                        :color="getQuantityColor(item.quantity)"
                        size="small"
                        >
                        {{ item.type=='package'?item.quantity:Math.abs(item.quantity) }}
                        </v-chip>
                    </template>
                    <template #item.check="{ item }">
                        <input type="checkbox" v-model="item.check">
                    </template>
                    </v-data-table>

                    <!-- Message quand aucune donnée -->
                    <v-alert
                    v-else-if="!selectedStoreId"
                    type="info"
                    variant="tonal"
                    class="mt-4"
                    >
                    Veuillez sélectionner un magasin pour afficher les quantités.
                    </v-alert>

                    <v-alert
                    v-else-if="selectedStoreId && displayedQuantities.length === 0"
                    type="warning"
                    variant="tonal"
                    class="mt-4"
                    >
                    Aucune quantité disponible pour ce magasin.
                    </v-alert>
                <!-- </v-card-text>
                <v-card-text> -->
                    
                    <PieQuantities 
                    v-if="['DEPO','NEGO','NGEXT','LO07'].includes(selectedStoreId)"
                    :data="productData"
                    :quantityLabels
                    :selectedQuantityPrime
                    :selectedStore="selectedStoreId"
                    ></PieQuantities>
                    <TauxRevente
                    :p_saison="'H26'"
                    :p_code_article="props.productData.id"
                    :p_codeabarre="props.productData.barcode"
                    @salesbystore="(value)=>{getsalesbystore(value)}"
                    ></TauxRevente>
                </v-card-text>

                    
                <v-card-actions class="py-1">
                    <v-spacer />
                    <v-btn variant="text"  @click="qteDialog = false" color="red">Fermer</v-btn>
                </v-card-actions>
                
            </v-card>
            </v-tabs-window-item>

            <v-tabs-window-item value="two" id="element-to-convert2">
                <v-card>
                    <v-card-text>
                        <v-row dense>
                        <v-col cols="12"  md="4" sm="6">
                            <v-text-field
                            density="compact" variant="outlined"
                            label="Acheteur"
                            
                            v-model="props.article.acheteur"
                            ></v-text-field>
                        </v-col>
                        <v-col  cols="12"  md="4"  sm="6"
                        >
                            <v-text-field  density="compact" variant="outlined" label="Pôle"     v-model="props.article.pole"
                            ></v-text-field>
                        </v-col>
            
                        <v-col  cols="12"  md="4"  sm="6"
                        >
                            <v-text-field
                            label="Code dounier" density="compact" variant="outlined"
                            
                            v-model="props.article.code_catdouanie"
                            ></v-text-field>
                        </v-col>
            
                        <v-col  cols="12" md="4"  sm="6"
                        >
                            <v-text-field
                            label="Composition" density="compact" variant="outlined"
                            
                            v-model="props.article.code_composition"
                            ></v-text-field>
                        </v-col>
            
                        <v-col cols="12"  md="4" sm="6"
                        >
                            <v-text-field
                            label="Pays" density="compact" variant="outlined"
                            
                            v-model="props.article.code_paysorigine"
                            ></v-text-field>
                        </v-col>
            
                        <v-col  cols="12"  md="4" sm="6"
                        >
                            <v-text-field
                            label="Fournisseur" density="compact" variant="outlined"
                            
                            v-model="props.article.code_fourn"
                            ></v-text-field>
                        </v-col>
            
                        <v-col  cols="12"  md="4"  sm="6"
                        >
                        <v-text-field
                            label="Code Thème" density="compact" variant="outlined"
                           
                            v-model="props.article.code_theme"
                            ></v-text-field>
                        </v-col>
            
                        <v-col cols="12" md="4"  sm="6">
                            <v-text-field
                                label="Code marque" density="compact" variant="outlined"
                                v-model="props.article.code_marque"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4"  sm="6">
                            <v-text-field
                                label="Classification" density="compact" variant="outlined"
                                v-model="props.article.code_sousfamille"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4" sm="6">
                            <v-text-field 
                                label="EAN13" 
                                v-model="props.article.ean13_y2" 
                                density="compact" 
                                variant="outlined" 
                                @change.prevent="update('ean13_y2', $event.target.value)">
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="4" sm="6">
                            <v-text-field label="Prix Achat" v-model="PrixAchat" density="compact" variant="outlined"></v-text-field>
                        </v-col>
                        
                        <v-col cols="12" md="4" sm="6">
                            <v-text-field 
                                label="Photo" 
                                v-model="props.article.photo_name" 
                                density="compact" 
                                variant="outlined" 
                                @change.prevent="update('photo_name', $event.target.value)">
                            </v-text-field>
                        </v-col>
                        </v-row>
                        <v-row>
                        <v-col cols="12" md="6" sm="6">
                            <v-checkbox label="NOT PIM" :title="props.article.pim?'Ne pas exporter vers Akénéo':'Exporter vers Akénéo'" style="margin-top: -10px;" v-model="props.article.pim" density="compact"></v-checkbox>
                        <!-- <v-btn color="red" @click="deletePromo();dialogFinale=true">Supprimer pormo</v-btn> -->
                        </v-col>
                        </v-row>
                        <!-- <small class="text-caption text-medium-emphasis">*indicates required field</small> -->
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red" text="Fermer" variant="plain" @click="qteDialog = false"></v-btn>
                        <v-btn color="primary" text="Valider" variant="plain" @click="qteDialog = false"></v-btn>
                    </v-card-actions>
                </v-card>
            </v-tabs-window-item>
        </v-tabs-window>
    </v-card>
    <!-- </card> -->
  </v-dialog>
</template>

<script setup>
    import { ref, watch,computed , onMounted } from 'vue'
    import PieQuantities from './PieQuantities.vue'
    import TauxRevente from './TauxRevente.vue'
    import store from '../store'
    import axios from 'axios'
    const qteDialog = defineModel()
    const props = defineProps({
      productData:{
        type: Object,
        required: true
      },
      storeOptions:{
        type: Array,
        required: true
      },
      type:{
        type: Object,
        required: true
      },
      article:{
        type: Object,
        required: true
      }
    })
    
    let tab=ref('one')
    // États
    const selectedStoreId = ref(store.state.etablissement)
    const displayedQuantities = ref([])
    let selectedQuantityPrime=ref('frontOfficeSalesQuantity')
    // console.log(props.productData);
    let productData=ref(props.productData)
    // Traductions
    const quantityLabels = {
        customerAvailableQuantity: { libelle: 'Qté disponible client', type: '' },
        customerCreditQuantity: { libelle: 'Qté crédit client', type: '' },
        customerDeliveryQuantity: { libelle: 'Qté livraison client', type: 'minus' },
        customerDeliveryPreparationQuantity: { libelle: 'Qté préparation livraison', type: '' },
        customerInvoiceQuantity: { libelle: 'Qté facture client', type: 'minus' },
        customerOrderQuantity: { libelle: 'Qté commande client', type: '' },
        customerReservationRequestQuantity: { libelle: 'Qté demande réservation', type: '' },
        deliveryNoticeQuantity: { libelle: 'Qté annonce de livraison', type: '' },
        frontOfficeSalesQuantity: { libelle: 'Qté ventes front office', type: 'minus' },
        initialInventoryQuantity: { libelle: 'Qté inventaire initial', type: 'plus' },
        inventoryDiscrepancyQuantity: { libelle: 'Écart d\'inventaire', type: 'plus' },
        orliPreparationQuantity: { libelle: 'Qté préparation ORLI', type: '' },
        outOfStockQuantity: { libelle: 'Rupture de stock', type: '' },
        physicalQuantity: { libelle: 'Qté physique', type: 'package' },
        specialInputDraftQuantity: { libelle: 'Qté entrée spéciale brouillon', type: '' },
        specialInputOutputQuantity: { libelle: 'Qté entrée/sortie spéciale', type: 'plus' },
        specialOutputDraftQuantity: { libelle: 'Qté sortie spéciale brouillon', type: 'minus' },
        supplierCreditQuantity: { libelle: 'Qté crédit fournisseur', type: 'plus' },
        supplierDeliveryQuantity: { libelle: 'Qté réception fournisseur', type: 'plus' },
        supplierInvoiceQuantity: { libelle: 'Qté facture fournisseur', type: '' },
        supplierOrderQuantity: { libelle: 'Qté commande fournisseur', type: '' },
        supplierPurchaseProposalQuantity: { libelle: 'Qté proposition achat', type: '' },
        supplierReturnDraftQuantity: { libelle: 'Qté retour fournisseur brouillon', type: 'minus' },
        supplierReturnQuantity: { libelle: 'Qté retour fournisseur', type: 'minus' },
        transferDraftQuantity: { libelle: 'Qté transfert brouillon', type: 'minus' },
        transferNoticeQuantity: { libelle: 'Qté avis de transfert', type: '' },
        transferQuantity: { libelle: 'Qté transfert', type: 'plus' },
        transferRequestQuantity: { libelle: 'Qté demande transfert', type: '' },
        webCartQuantity: { libelle: 'Qté panier web', type: '' }
    };
    let sommeCheckee = computed(() => {
        return displayedQuantities.value
            .filter(item => item.check === true && item.type !== '')
            .reduce((total, item) => {
                const quantite = Math.abs(item.quantity) // Valeur absolue
                if (item.type === 'plus') {
                    return total + quantite
                } else if (item.type === 'minus') {
                    return total - quantite
                }
                return total // Si type inconnu, on ne fait rien
            }, 0)
    })
    let PrixAchat=ref(null)
    // En-têtes
    const headers = [
    { title: 'Type de quantité', key: 'label', sortable: true, align: 'center' },
    { title: 'Type Mvt', key: 'type', sortable: true, align: 'center' },
    { title: 'Valeur', key: 'quantity', sortable: true, align: 'center' },
    { title: sommeCheckee, key: 'check', align: 'center' }
    ]

    let crossDock=ref(false)
    const updateDisplayedQuantities = () => {
        if (!props.productData || !selectedStoreId.value) {
            displayedQuantities.value = []
            return
        }

        const stores = props.productData.stores.find(s => s.id === selectedStoreId.value)
        if (!stores?.warehouses?.length) {
            displayedQuantities.value = []
            return
        }

        const warehouse = stores.warehouses[0]
        if (!warehouse?.quantities) {
            displayedQuantities.value = []
            return
        }

        displayedQuantities.value = Object.entries(warehouse.quantities)
            .filter(([_, value]) => value !== 0)
            .map(([key, value]) => ({
            label: key,
            type: quantityLabels[key].type,
            quantity: value,
            check : false,
            key: key
            }))
            .sort((a, b) => a.label.localeCompare(b.label))
            crossDock.value=displayedQuantities.value.filter(item => {return item.label == 'deliveryNoticeQuantity'}).length>0?true:false
            
    }
    
    // console.log(displayedQuantities.value);url: `https://my.edisac.com/api/update/${id}`,
    async function getsalesbystore(data){
        // console.log('salesbystore.value',data);
        productData.value=data
    }
    async function update(id,value){
        let data={
            id:id,
            value:value,
            codebarre:props.article.codebarre
        }
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `https://my.edisac.com/api/update/${id}`,
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${store.state.user.token}`   // ⬅️ Ajout du token
            },
            data:data
        };
        axios.request(config)
        .then((response) => {
            // console.log(response);
        
        })
        .catch((error) => {
        })
    }

    const getQuantityColor = (value) => {
    if (value > 0) return 'success'
    if (value < 0) return 'error'
    return 'grey'
    }

    // Watchers
    
    watch(selectedStoreId, updateDisplayedQuantities)
    onMounted(()=>{
        // console.log(props.productData);
        updateDisplayedQuantities()
    })
</script>

<style scoped>
.v-card {
  margin: 20px;
}

.v-data-table {
  margin-top: 16px;
}

.v-chip {
  font-weight: 500;
  min-width: 60px;
  justify-content: center;
}

:deep(.v-data-table-header th) {
  background-color: #f5f5f5 !important;
  font-weight: bold !important;
}
.dimension-vatican {
    font-family: 'Times New Roman', 'Georgia', serif;
    font-style: italic;
    
}

</style>